import { apiClient } from "src/careflow/ph-core/api_client/api_client";

export interface TenantI {
  name: string;
  code: string;
}

const base = 'auth-tenant';

const TenantApi = {
  getAllTenants: async () => apiClient.get<TenantI[]>(`${base}/get-tenants`),
  getAllOrganizations: () => apiClient.get<any>(`${base}/get-organizations`),
};

export const TenantService = {
  getAllTenants: async () => {
    const response = TenantApi.getAllTenants();
    if(!response) return [];
    return response;
  },

  getAllOrganizations: () => {
    const response = TenantApi.getAllOrganizations();
    if(!response) return [];
    return response;
  }
};